import React, { useState } from "react";
import { Col, Row } from "@/utils/bootstrap";
import ClearCartModal from "./ClearCartModal";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  itemsCount: number;
}

const CartHeader: React.FC<Props> = ({ itemsCount }) => {
  const [show, setShow] = useState(false);
  const t = useTranslation();
  return (
    <>
      <Row className="m-0 justify-content-between align-items-center">
        <Col
          as="p"
          className="p-0 m-0 items-in-cart"
        >{`${t.items_in_the_cart} (${itemsCount}):`}</Col>
        <Col className="p-0 col-auto cart-clear" onClick={() => setShow(true)}>
          {t.clear_cart}
        </Col>
      </Row>
      <ClearCartModal show={show} setShow={setShow} />
    </>
  );
};

export default CartHeader;
